"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemGroup = require("@/api/systemGroup");
var _devise = require("@/api/devise");
var _clipboard = _interopRequireDefault(require("clipboard"));
var _systemConfig = require("@/api/systemConfig");
var _linkaddress = _interopRequireDefault(require("@/components/linkaddress"));
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  name: 'index',
  data: function data() {
    return {
      iframeUrl: '',
      menuList: [],
      menuInfo: {},
      typeName: '',
      currentPage: 'home',
      modelBanner: ['https://image.java.crmeb.net/crmebimage/maintain/2021/07/06/c99ee385e94d4711a0ea4be72169a86euwmzuhxbb2.jpg'],
      urlbg: require('@/assets/imgs/user_bg.png'),
      indexTab: [],
      dataList: [],
      addUrlStatus: true,
      infoStatus: false,
      showStatus: false,
      shows: 0,
      indextTabMenu: [],
      tabActive: 0,
      cate: false,
      tip: false,
      mockGoods: false,
      mockGoodsImg: require('@/assets/theme/goodsList1.png'),
      showTabNav: true,
      cateArr: [{
        img: require('@/assets/imgs/moren.png'),
        tit: '默认模板'
      }, {
        img: require('@/assets/imgs/youxuan.png'),
        tit: '模板1'
      }, {
        img: require('@/assets/imgs/haowu.png'),
        tit: '模板2'
      }, {
        img: require('@/assets/imgs/shengxian.png'),
        tit: '模板3'
      }],
      cateImg: '',
      active: 3,
      HomeStyle: 1,
      //移动端首页样式
      disabled: false,
      radio: true,
      logoUrl: '',
      newsInfo: '',
      listActive: 0,
      tabList: ['首页', '分类', '个人中心', '底部菜单'],
      itemIndex: 0,
      navigationListTab: [],
      //底部导航左侧展示
      navigationList: [],
      isCustom: 0,
      diyWhere: {
        page: 1,
        limit: 10,
        name: '1'
      },
      diyListData: []
    };
  },
  components: {
    linkaddress: _linkaddress.default
  },
  created: function created() {
    this.iframeUrl = "https://app.beta.java.crmeb.net?type=iframeVisualizing";
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:page:layout:bottom:navigation'])) this.getBottomNavigation();
    //监听子页面给当前页面传值
    window.addEventListener('message', this.handleMessage, false);
    this.designList();
    this.$set(this, 'typeName', '');
    this.$set(this, 'tip', true);
    this.$nextTick(function () {
      var _this2 = this;
      var clipboard = new _clipboard.default('.copy-data');
      clipboard.on('success', function () {
        _this2.$message.success('复制成功');
      });
    });
    this.getLogo();
    this.kindGet();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    //删除底部菜单中的配置项
    handleDelMenu: function handleDelMenu(item, index) {
      this.navigationList.splice(index, 1);
      this.navigationListTab.splice(index, 1);
    },
    //走马灯切换
    carouselChange: function carouselChange(e) {
      this.active = e + 1;
      this.active = this.active.toString();
    },
    //同步获取diy列表
    getDiyListAsyc: function getDiyListAsyc(data) {
      return new Promise(function (resolve, reject) {
        (0, _devise.diyListApi)(data).then(function (res) {
          resolve(res);
        });
      });
    },
    //跳转添加主题
    handlerEditDiyPage: function handlerEditDiyPage(id, type) {
      var _this$$router$resolve = this.$router.resolve({
          path: "/page/design/creatDevise/".concat(id, "/").concat(type)
        }),
        href = _this$$router$resolve.href;
      window.open(href);
    },
    // 获取logo
    getLogo: function getLogo() {
      var _this3 = this;
      (0, _systemConfig.configInfo)({
        id: 77
      }).then(function (res) {
        _this3.$set(_this3, 'logoUrl', res.mobile_top_logo);
      });
    },
    addBox: function addBox() {
      if (this.typeName == 'bottomNavigation') {
        var indexMenu = JSON.parse(JSON.stringify(this.navigationList[0]));
        indexMenu.id = null;
        indexMenu.name = '';
        indexMenu.url = '';
        indexMenu.checked = '';
        indexMenu.unchecked = '';
        this.navigationList.push(indexMenu);
      } else if (this.menuList.length >= 10 && this.typeName == 'indexMenu') {
        this.$message.warning('设置数据不能超过10条');
      } else if (this.typeName == 'indexTabNav' && this.menuList.length >= 4) {
        this.addUrlStatus = false;
        this.infoStatus = true;
        this.$message.warning('设置数据不能超过4条');
      } else {
        var _indexMenu = JSON.parse(JSON.stringify(this.menuList[0]));
        _indexMenu.id = null;
        _indexMenu.name = '';
        _indexMenu.url = '';
        _indexMenu.info = '';
        _indexMenu.pic = '';
        this.menuList.push(_indexMenu);
      }
    },
    //获取底部导航
    getBottomNavigation: function getBottomNavigation() {
      var _this4 = this;
      (0, _systemGroup.getBottomNavigationApi)().then(function (res) {
        _this4.navigationList = res.bottomNavigationList;
        var data = res.bottomNavigationList.filter(function (item) {
          return item.status;
        });
        _this4.navigationListTab = data;
        _this4.isCustom = Number(res.isCustom);
      });
    },
    // 获取列表值；
    designList: function designList() {
      var _this5 = this;
      (0, _systemGroup.designListApi)().then(function (res) {
        _this5.menuInfo = res;
        var newArr = [];
        var indexMenu = res.indexMenu.filter(function (item, index, arr) {
          return item.status == true;
        });
        var indexBanner = res.indexBanner.filter(function (item, index, arr) {
          return item.status == true;
        });
        var userMenu = res.userMenu.filter(function (item, index, arr) {
          return item.status == true;
        });
        var indexNews = res.indexNews.filter(function (item, index, arr) {
          return item.status == true;
        });
        var userBanner = res.userBanner.filter(function (item, index, arr) {
          return item.status == true;
        });
        newArr.push(indexMenu, indexBanner, userMenu, indexNews, userBanner);
        _this5.dataList = newArr;
        _this5.$set(_this5, 'newsInfo', indexNews[0] ? indexNews[0].info : '这是一个新闻标题');
      });
      (0, _systemGroup.goodDesignList)({
        gid: 70
      }).then(function (response) {
        var list = response.list;
        var arr = [];
        var arr1 = [];
        list.forEach(function (item) {
          var obj = {};
          obj.value = JSON.parse(item.value);
          obj.id = item.id;
          obj.gid = item.gid;
          obj.status = item.status;
          arr.push(obj);
        });
        arr.forEach(function (item1) {
          var obj1 = {};
          obj1.pic = item1.value.fields[0].value;
          obj1.name = item1.value.fields[1].value;
          obj1.info = item1.value.fields[2].value;
          obj1.type = item1.value.fields[3].value;
          obj1.id = item1.id;
          obj1.gid = item1.gid;
          // obj1.show = '1';
          obj1.status = item1.status;
          arr1.push(obj1);
          _this5.indextTabMenu = arr1;
          var indexTab = arr1.filter(function (item, index, arr) {
            return item.status == true;
          });
          _this5.indexTab = indexTab;
        });
        //
      });
    },
    //
    handleMessage: function handleMessage(event) {
      // this.typeName = event.data.name;
      this.typeName = event;
      switch (event) {
        case 'bottomNavigation':
          this.shows = 8;
          this.menuList = [];
          break;
        case 'indexMenu':
          this.menuList = this.menuInfo.indexMenu;
          this.shows = 3;
          this.mockGoods = false;
          break;
        case 'indexBanner':
          this.menuList = this.menuInfo.indexBanner;
          this.shows = 1;
          this.mockGoods = false;
          break;
        case 'userMenu':
          this.menuList = this.menuInfo.userMenu;
          this.shows = 6;
          this.mockGoods = false;
          break;
        case 'indexNews':
          this.menuList = this.menuInfo.indexNews;
          this.shows = 2;
          this.mockGoods = false;
          break;
        case 'userBanner':
          this.menuList = this.menuInfo.userBanner;
          this.shows = 5;
          this.mockGoods = false;
          break;
        case 'indexTabNav':
          this.menuList = this.indextTabMenu;
          this.shows = 4;
          this.mockGoods = false;
          break;
        case 'goodsMock':
          this.mockGoods = true;
          this.typeName = '';
          this.tip = false;
          this.shows = 7;
          break;
      }
    },
    switchNav: function switchNav(index) {
      this.tabActive = index;
    },
    // 点击商品图
    modalPicTap: function modalPicTap(tit, num, i, boolean) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (tit === '1' && num === 'duo') {
          _this.menuList[i].pic = img[0].sattDir;
        }
        if (tit === '2') {
          _this.navigationList[i].checked = img[0].sattDir;
        }
        if (tit === '3') {
          _this.navigationList[i].unchecked = img[0].sattDir;
        }
      }, tit, 'content', true);
    },
    // 删除
    bindDelete: function bindDelete(item, index) {
      this.menuList.splice(index, 1);
    },
    saveConfig: (0, _validate.Debounce)(function () {
      switch (this.typeName) {
        case 'indexMenu':
          this.saveData('indexMenu', '/admin/page/layout/index/menu/save');
          break;
        case 'indexBanner':
          this.saveData('indexBanner', '/admin/page/layout/index/banner/save');
          break;
        case 'userMenu':
          this.saveData('userMenu', '/admin/page/layout/user/menu/save');
          break;
        case 'indexNews':
          this.saveData('indexNews', '/admin/page/layout/index/news/save');
          break;
        case 'userBanner':
          this.saveData('userBanner', '/admin/page/layout/user/banner/save');
          break;
        case 'indexTabNav':
          this.saveData('indexTable', '/admin/page/layout/index/table/save');
        case 'bottomNavigation':
          this.saveData('bottomNavigation', '/admin/page/layout/bottom/navigation/save');
          break;
      }
    }),
    saveData: function saveData(param, url) {
      var _this6 = this;
      var tArr = this.menuList.filter(function (item, index, arr) {
        return item.status === true;
      });
      var navigationList = this.navigationList.filter(function (item, index, arr) {
        return item.status === true;
      });
      var data = {};
      if (param === 'bottomNavigation') {
        data = {
          bottomNavigationList: this.changeIndex(this.navigationList),
          isCustom: this.isCustom
        };
        if (navigationList.length < 3) return this.$message.warning('设置数据不能小于3条');
      } else {
        if (param === 'indexMenu' && tArr.length < 5) return this.$message.warning('设置数据不能小于5条');
        if (param === 'indexTabNav' && tArr.length < 2) return this.$message.warning('设置数据不能小于2条');
        if (param === 'indexNews' && tArr.length < 1) return this.$message.warning('设置数据不能小于1条');
        data = _defineProperty({}, param, this.changeIndex(this.menuList));
      }
      (0, _systemGroup.SaveDataApi)(data, url).then(function (res) {
        _this6.$message.success('保存成功');
        if (param === 'bottomNavigation') {
          _this6.getBottomNavigation();
        } else {
          _this6.designList();
        }
      });
    },
    changeIndex: function changeIndex(array) {
      array.map(function (item, index) {
        item.sort = index;
      });
      return array;
    },
    // 移动
    handleDragStart: function handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd: function handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver: function handleDragOver(e) {
      e.dataTransfer.dropEffect = 'move';
    },
    handleDragEnter: function handleDragEnter(e, item, data, name) {
      e.dataTransfer.effectAllowed = 'move';
      if (item === this.dragging) {
        return;
      }
      var newItems = _toConsumableArray(data);
      var src = newItems.indexOf(this.dragging);
      var dst = newItems.indexOf(item);
      newItems.splice.apply(newItems, [dst, 0].concat(_toConsumableArray(newItems.splice(src, 1))));
      if (name === 'menuList') {
        this.menuList = newItems;
      } else {
        this.navigationList = newItems;
        this.navigationListTab = newItems;
      }
    },
    showCurrent: function showCurrent(name) {
      this.currentPage = name;
      this.$set(this, 'typeName', '');
      this.$set(this, 'tip', true);
      this.$set(this, 'cate', false);
    },
    showTip: function showTip() {
      this.$message.warning('暂不支持此操作');
    },
    cateNav: function cateNav() {
      this.currentPage = 'cate';
      this.$set(this, 'typeName', '');
      this.$set(this, 'cate', true);
      this.$set(this, 'mockGoods', false);
      this.getConfig();
    },
    switchTab: function switchTab(index) {
      this.$refs.carousel.setActiveItem(index - 1);
    },
    switchKind: function switchKind(index) {
      this.HomeStyle = index;
      switch (index) {
        case '1':
          this.$set(this, 'mockGoodsImg', require('@/assets/theme/goodsList1.png'));
          this.$set(this, 'showTabNav', true);
          break;
        case '2':
          this.$set(this, 'mockGoodsImg', require('@/assets/theme/goodsList2.png'));
          this.$set(this, 'showTabNav', false);
          break;
        case '3':
          this.$set(this, 'mockGoodsImg', require('@/assets/theme/goodsList3.png'));
          this.$set(this, 'showTabNav', false);
          break;
      }
    },
    save: (0, _validate.Debounce)(function () {
      var _this7 = this;
      var data = {
        category_page_config: this.active,
        is_show_category: this.radio
      };
      (0, _systemGroup.SaveDataApi)(data, '/admin/page/layout/category/config/save').then(function (res) {
        _this7.$message.success('保存成功');
      });
    }),
    getConfig: function getConfig() {
      var _this8 = this;
      (0, _systemGroup.getDataApi)().then(function (res) {
        _this8.$set(_this8, 'active', res.categoryConfig);
        _this8.$set(_this8, 'radio', res.isShowCategory == 'true' ? true : false);
        _this8.switchTab(_this8.active);
      });
    },
    kindSave: (0, _validate.Debounce)(function () {
      var _this9 = this;
      var data = {
        value: this.HomeStyle
      };
      (0, _systemConfig.savehomeStyleApi)(data).then(function (res) {
        _this9.$message.success('保存成功');
      });
    }),
    kindGet: function kindGet() {
      var _this10 = this;
      (0, _systemConfig.getHomeStyleApi)().then(function (res) {
        _this10.$set(_this10, 'HomeStyle', res.value);
        if (_this10.HomeStyle == '1') {
          _this10.$set(_this10, 'mockGoodsImg', require('@/assets/theme/goodsList1.png')); //showTabNav
          _this10.$set(_this10, 'showTabNav', true);
        } else if (_this10.HomeStyle == '2') {
          _this10.$set(_this10, 'mockGoodsImg', require('@/assets/theme/goodsList2.png'));
          _this10.$set(_this10, 'showTabNav', false);
        } else if (_this10.HomeStyle == '3') {
          _this10.$set(_this10, 'mockGoodsImg', require('@/assets/theme/goodsList3.png'));
          _this10.$set(_this10, 'showTabNav', false);
        }
      });
    },
    getLink: function getLink(index) {
      this.itemIndex = index;
      this.$refs.linkaddres.dialogVisible = true;
    },
    ProductNavTab: function ProductNavTab(index) {
      var _this11 = this;
      this.listActive = index;
      if (index == 0) {
        this.showCurrent('home');
      } else if (index == 1) {
        this.cateNav();
      } else if (index == 2) {
        this.showCurrent('user');
      } else if (index == 3) {
        this.showCurrent('bottom');
      } else if (index == 4) {
        this.getDiyListAsyc(this.diyWhere).then(function (res) {
          _this11.showCurrent('diy');
          _this11.diyListData = res.list;
        });
      }
    },
    linkUrl: function linkUrl(e) {
      if (this.typeName == 'bottomNavigation') {
        this.navigationList[this.itemIndex].link = e;
      } else {
        this.menuList[this.itemIndex].url = e;
      }
    }
  }
};